import ApiService from './ApiService';

class OrderQuotationService {
  async getOrderQuotation(payload = {}) {
    try {
      const response = await ApiService.call('/secured/get_order_quotation_list', 'POST', payload);
      let data = response;

      return {
        orderQuotationList: data.result,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new OrderQuotationService();
